import React from "react";
import AuthPage from "./account/AuthPage";
export default function Login() {
  return <AuthPage mode="login" />;
}
